import { IdNumberValidator } from "./IdNumberValidator";

export class NifPersonaJuridicaValidator extends IdNumberValidator<string> {
  private sanitizeNIF = function (str: string): string {
    // Ensure uppercase and remove whitespace ang hyphens
    return str.toUpperCase().replace(/\s/g, "").replace(/-/g, "");
  };

  public validate(nif: string): boolean {
    nif = this.sanitizeNIF(nif);

    if (nif.length !== 9) return false;

    const letters = ["J", "A", "B", "C", "D", "E", "F", "G", "H", "I"];
    const digits = nif.substring(1, nif.length - 1);
    const letter = nif.substring(0, 1);
    const control = nif.substring(nif.length - 1);
    let sum = 0;
    let i = 0;
    let digit = 0;

    if (!letter.match(/[ABCDEFGHJKLMNPQRSUVW]/)) return false;

    for (i = 0; i < digits.length; ++i) {
      if (!digits[i]) return false;

      digit = parseInt(digits[i], 10);

      if (isNaN(digit)) return false;

      if (i % 2 === 0) {
        digit *= 2;
        if (digit > 9) digit = Math.floor(digit / 10) + (digit % 10);
      }
      sum += digit;
    }

    sum %= 10;
    digit = sum !== 0 ? 10 - sum : sum;

    if (letter.match(/[ABEH]/)) {
      if (String(digit) !== control) {
        return false;
      }
    }

    if (letter.match(/[NPQRSW]/)) {
      if (letters[digit] !== control) {
        return false;
      }
    }

    if (String(digit) !== control && letters[digit] !== control) {
      return false;
    }

    return true;
  }
}
